import axiosInstance from '@/services/axiosInstance';
import { pickBody } from '@/api/helpers';

export type CalendarVisibilityPreferences = {
  organizationId: string;
  userId: string;
  showEvents: boolean;
  showTasks: boolean;
  showPmsProjects: boolean;
  showNotes: boolean;
  showMeetings: boolean;
  showHolidays: boolean;
  showOrgEvents: boolean;
  showAttendance: boolean;
  updatedAt: string | null;
};

export type PatchCalendarVisibilityInput = Partial<
  Pick<
    CalendarVisibilityPreferences,
    | 'showEvents'
    | 'showTasks'
    | 'showPmsProjects'
    | 'showNotes'
    | 'showMeetings'
    | 'showHolidays'
    | 'showOrgEvents'
    | 'showAttendance'
  >
>;

const getMine = (): Promise<CalendarVisibilityPreferences> =>
  axiosInstance.get<unknown>('/api/v1/me/calendar-visibility').then((res) => {
    const raw = pickBody<{ success?: boolean; data: CalendarVisibilityPreferences }>(res.data);
    return raw.data;
  });

const patchMine = (input: PatchCalendarVisibilityInput): Promise<CalendarVisibilityPreferences> =>
  axiosInstance.patch<unknown>('/api/v1/me/calendar-visibility', input).then((res) => {
    const raw = pickBody<{ success?: boolean; data: CalendarVisibilityPreferences }>(res.data);
    return raw.data;
  });

const calendarVisibilityApi = {
  getMine,
  patchMine,
};

export { calendarVisibilityApi };
